// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__MbNCM","btnOffer":"AddProduct_btnOffer__U8Jj3"};